import { createContext, useContext, useState, useCallback } from 'react';
import { useTheme } from './theme';

const ToastCtx = createContext({ toast: () => {} });

export function useToast() { return useContext(ToastCtx); }

export function ToastProvider({ children }) {
  const { theme, isDark } = useTheme();
  const [toasts, setToasts] = useState([]);

  const toast = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4000);
  }, []);

  const colors = {
    success: { bg: isDark ? 'rgba(22,163,74,0.15)' : '#dcfce7', border: '#16a34a', text: '#16a34a' },
    error: { bg: isDark ? 'rgba(220,38,38,0.15)' : '#fee2e2', border: '#dc2626', text: '#dc2626' },
    info: { bg: isDark ? 'rgba(59,130,246,0.15)' : '#dbeafe', border: '#3b82f6', text: '#3b82f6' },
  };

  return (
    <ToastCtx.Provider value={{ toast }}>
      {children}
      <div style={{ position: 'fixed', top: 16, right: 16, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map(t => {
          const c = colors[t.type] || colors.info;
          return (
            <div key={t.id} style={{
              padding: '10px 16px', borderRadius: 10, background: c.bg,
              border: `1px solid ${c.border}`, color: c.text, fontSize: 14,
              fontWeight: 500, maxWidth: 360, boxShadow: theme.shadowLg,
              animation: 'fadeIn 0.2s ease',
            }}>
              {t.message}
            </div>
          );
        })}
      </div>
    </ToastCtx.Provider>
  );
}
